import React from "react";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";

/**
 * Slow editorial marquee. Duplicates content for seamless loop.
 */
export const Marquee = () => {
  const items = [
    "MIND",
    "·",
    "BODY",
    "·",
    "SOUL",
    "—",
    "BUILT IN SILENCE",
    "·",
    "TRAINED AT ALTITUDE",
    "·",
    "EST. XXV",
    "—",
  ];
  const line = [...items, ...items, ...items];

  return (
    <section
      data-testid={HOME.marquee}
      className="relative bg-black border-y border-white/10 py-8 md:py-10 overflow-hidden"
    >
      <motion.div
        className="flex whitespace-nowrap will-change-transform"
        animate={{ x: ["0%", "-33.333%"] }}
        transition={{ repeat: Infinity, duration: 55, ease: "linear" }}
      >
        {line.map((word, i) => (
          <span
            key={i}
            className="font-serif italic text-[10vw] md:text-[7vw] leading-none mx-6 md:mx-10 text-white/85"
            style={{
              WebkitTextStroke:
                word === "·" || word === "—" ? "0" : "1px rgba(255,255,255,0.08)",
              color: word === "·" || word === "—" ? "#8A8D93" : undefined,
            }}
          >
            {word}
          </span>
        ))}
      </motion.div>
    </section>
  );
};

export default Marquee;
